/* bl-buybox-cart.js
 * Intercepta el <form data-bb-form> del buybox (seccion bl-pdp-buybox): agrega via AJAX
 * el pack seleccionado y, si ese pack tiene regalo (radio con data-gift-id), agrega
 * tambien la variante de regalo a precio 0 con la propiedad "Regalo: Gratis". Luego
 * dispara el evento 'cart:update' del tema para que el cart-drawer lateral se abra y
 * se refresque (igual que el boton nativo). Fallback a /cart si no hay drawer o falla.
 */
(function () {
  function getSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      var sid = c.getAttribute('data-section-id');
      if (sid && ids.indexOf(sid) === -1) ids.push(sid);
    });
    return ids;
  }

  function cartAddUrl() {
    try { if (window.Theme && Theme.routes && Theme.routes.cart_add_url) return Theme.routes.cart_add_url; } catch (e) {}
    return '/cart/add.js';
  }

  function cartUrl() {
    try { if (window.Theme && Theme.routes && Theme.routes.cart_url) return Theme.routes.cart_url; } catch (e) {}
    return '/cart';
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || typeof form.matches !== 'function' || !form.matches('form[data-bb-form]')) return;

      event.preventDefault();
      if (form.dataset.adding === '1') return;

      var sel = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      if (!sel || sel.disabled) return;

      // Pack seleccionado + regalo opcional (data-gift-id en el radio)
      var items = [{ id: sel.value, quantity: 1 }];
      var giftId = sel.getAttribute('data-gift-id');
      if (giftId) {
        var gid = parseInt(giftId, 10);
        if (gid) items.push({ id: gid, quantity: 1, properties: { 'Regalo': 'Gratis' } });
      }

      var btn = form.querySelector('.bl-btn--atc');
      var prevText = btn ? btn.textContent : '';
      form.dataset.adding = '1';
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'AGREGANDO...';
      }

      function restore() {
        form.dataset.adding = '';
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.textContent = prevText;
        }
      }

      var ids = getSectionIds();
      var payload = { items: items };
      if (ids.length) payload.sections = ids.join(',');

      fetch(cartAddUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          return r.json().then(function (data) {
            return { ok: r.ok, data: data };
          });
        })
        .then(function (res) {
          var data = res.data || {};
          if (!res.ok || data.status) {
            restore();
            window.alert(data.description || data.message || 'No se pudo agregar al carrito.');
            return;
          }
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var evt = new Event('cart:update', { bubbles: true });
              evt.detail = {
                resource: cart,
                sourceId: 'bl-buybox',
                data: {
                  source: 'product-form-component',
                  sections: data.sections,
                  itemCount: cart.item_count
                }
              };
              document.dispatchEvent(evt);
              restore();
              if (!document.querySelector('cart-drawer-component')) {
                window.location.href = cartUrl();
              }
            });
        })
        .catch(function (err) {
          console.error('[bl-buybox-cart]', err);
          restore();
          window.location.href = cartUrl();
        });
    },
    true
  );
})();
